import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { usePostListingById } from 'src/hooks/usePostListing';
import type { StoreProps } from 'src/store';
import { createPostListingUrl } from 'src/utils';

export const usePaymentSuccessPostListing = (listingId: string | null) => {
  const postListingById = usePostListingById();
  const clientId = useSelector((store: StoreProps) => store.account.id);

  useEffect(() => {
    const handlePostListingById = async () => {
      if (
        typeof listingId === 'string' &&
        postListingById.status.kind === 'idle'
      ) {
        const result = await postListingById.post(listingId);

        if (
          result.kind === 'error' &&
          result.error.type === 'account_pending_review'
        ) {
          // User has just paid and is attempting to post/repost ad but their account is in pending review.
          // Navigate them to CASBA, so that they can continue to post their ad through the pending flow
          const casbaPreviewPage = createPostListingUrl(
            clientId,
            Number(listingId),
          );
          window.location.assign(casbaPreviewPage);
          return;
        }
      }
    };

    handlePostListingById();
  }, [listingId, postListingById, clientId]);

  return postListingById.status;
};
